import React, { useContext, useCallback } from 'react'
import Font from '@cred/react-font'
import PropTypes from 'prop-types'
import { ResizedImage } from '@cred/react-resized-image'
import { fireGtmEvent } from 'utils/gtm'
import WidgetContext from 'components/widget-context'
import CtaButton from 'components/cta-button'
import { event } from '@cred/shared/ga'
import { creditCard as spCreditCard } from '@cred/react-analytics/contexts'
import { SnowplowContext } from '@cred/react-analytics/SnowplowContextManager'
import Link from 'components/link'
import styles from './styles.scss'

const ImageAndMobCTA = ({
  image, name, ctaUrl, issuerPublicName, ratesAndFeesUrl, category, uuid,
}) => {
  const widgetContext = useContext(WidgetContext),
    onClickCta = useCallback(() => {
      fireGtmEvent('ctaClick',
        { category, ...widgetContext })
      event({ category, action: 'Apply Now CTA Click', label: category })
    }, [category, widgetContext]),
    onLinkClick = useCallback(() => {
      fireGtmEvent('linkClick',
        { category, ...widgetContext })
      event({ category, action: 'Rates and Fees Link Click', label: 'Rates and Fees' })
    }, [category, widgetContext]),
    ctaContext = [
      spCreditCard.analytics({ redirectUUID: uuid, issuer: issuerPublicName, cardName: name, category }),
    ]
  return (
    <div className={styles.imageAndMobCta}>
      <ResizedImage className={styles.cardImage} src={image} alt={`${name} logo`} width={91} height={55} />
      <div className={`mt-8 ${styles.ctaMob}`}>
        <SnowplowContext contexts={ctaContext}>
          <CtaButton
            small
            blank
            href={ctaUrl}
            onClick={onClickCta}
          >
          Apply Now
          </CtaButton>
        </SnowplowContext>
        <Font type="disclaimer" color="lighter" className={styles.customFont}>
          {`on ${issuerPublicName}'s Website`}
        </Font>
        {!!ratesAndFeesUrl && (
          <Font type="disclaimer" weight="semiBold" color="secondary">
            <Link
              underline="dashed"
              blank
              rel="nofollow"
              className={styles.customFont}
              href={ratesAndFeesUrl}
              onClick={onLinkClick}
            >
                        Rates and fees
            </Link>
          </Font>
        ) }
      </div>
    </div>
  )
}

ImageAndMobCTA.propTypes = {
  name: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  ratesAndFeesUrl: PropTypes.string,
  issuerPublicName: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
}

export { ImageAndMobCTA }

export default ImageAndMobCTA
